var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"invalid-feedback":_vm.invalidFeedback,"state":_vm.state}},[_c('input',{ref:"eventDatePretty",staticClass:"form-control",class:_vm.inputClass,attrs:{"id":"event_date","type":"text","state":_vm.state,"readonly":""},domProps:{"value":_vm.datePretty}})])
}
var staticRenderFns = []

export { render, staticRenderFns }